module.exports = __webpack_public_path__ + "static/media/icon_209.f4f39815.svg";